import React, { FC } from 'react';
import StoreCatalog from 'src/components/pages/productConfiguration/storeCatalog/storeCatalog';
import { Dialog, DialogWindow } from 'src/components/widgets/dialog';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ComposerPlatformProduct, normalizeComposerPlatformMetadata } from '../helpers/composerPlatformPricing';

const ProductDialogWindow = styled(DialogWindow)`
    width: min(1180px, calc(100vw - 80px));
    height: min(780px, calc(100vh - 80px));
`;

const ComposerPlatformProductDialog: FC<{
    salesChannelID: string;
    forbiddenProductCode: string;
    onClose: () => void;
    onSelect: (product: ComposerPlatformProduct) => void;
}> = ({ salesChannelID, forbiddenProductCode, onClose, onSelect }) => (
    <Dialog
        title={T._('Select a product from your store', 'Admin')}
        windowDecorator={ProductDialogWindow}
        onClose={onClose}
        buttons={[{ label: T._('Cancel', 'Admin'), outline: true, onClick: onClose }]}
    >
        <StoreCatalog
            salesChannelID={salesChannelID}
            disableProductCode={forbiddenProductCode}
            hideAlreadyConfiguredBadge
            onProductClick={(product: any) => {
                onSelect({
                    code: product.sku,
                    name: product.name,
                    thumbnail: product.thumbnail,
                    metadata: normalizeComposerPlatformMetadata(product.metadata)
                });
                onClose();
            }}
        />
    </Dialog>
);

export default ComposerPlatformProductDialog;
